//cannot contain Dates, functions, Infinity, RegExps, Maps, Sets, Blobs, FileLists, ImageDatas, sparse Arrays, Typed Arrays or other complex types
export default {
  company: undefined,
  brand: undefined,
};
